import React from "react";
import GelleryData from "../components/GelleryData";

function Gellery() {
  return (
    <div>
      <GelleryData />
    </div>
  );
}

export default Gellery;
